import './header-info.scss';

import InfoCard from '@/components/Shared/InfoCard';
import ChevronDownIcon from '@/media/icons/chevron-down.svg?react';
import EditIcon from '@/media/icons/edit.svg?react';
import PhoneIcon from '@/media/svg/phone.svg?react';
import { formatPhoneNumber } from '@/services/formatter';
import { getUserFullName } from '@/services/helpers/strings';
import { useAppSelector } from '@/store';

import { getAutoInfo } from '../../helpers';

interface IProps {
  openEditModal?: () => void;
  onHistoryModalOpenChange: (value: boolean) => void;
}

const HeaderInfo: React.FC<IProps> = ({
  openEditModal,
  onHistoryModalOpenChange
}) => {
  const { request } = useAppSelector((state) => state.ieLeasingOrder);

  const autoInfo = getAutoInfo(request);

  return (
    <div className="ie-header-info">
      <InfoCard
        title={getUserFullName(request?.client, {
          defaultValues: {
            firstName: '-',
            lastName: '-',
            middleName: '-'
          }
        })}
        icon={!!openEditModal && <EditIcon className="ie-header-info__icon" />}
        onClick={openEditModal}
        subtitle={`ИИН: ${request?.client?.clientIin}`}
      />
      <InfoCard
        title={formatPhoneNumber(request?.client?.phoneNumber)}
        subtitle="Номер телефона"
        isPhoneNumber
        icon={<PhoneIcon className="ie-header-info__icon" />}
      />
      {request?.status.code !== 'leasing_draft' && (
        <div className="ie-header-info__auto">
          <InfoCard
            title={
              <span className="ie-header-info__auto-title">
                {autoInfo.label || 'Нет данных'}
                {autoInfo.subjects.length > 0 && (
                  <ChevronDownIcon className="ie-header-info__auto-chevron" />
                )}
              </span>
            }
            subtitle={`${autoInfo.amount || '0'} ₸`}
          />
          {autoInfo.subjects.length > 0 && (
            <div className="ie-header-info__subjects">
              <div className="ie-header-info__subjects-card">
                {autoInfo.subjects.map((subject) => (
                  <div className="ie-header-info__subject" key={subject.id}>
                    <div>
                      <p className="ie-header-info__subject-title">
                        {subject.title}
                      </p>
                      <p className="ie-header-info__subject-meta">
                        {subject.quantityLabel}
                      </p>
                    </div>
                    <p className="ie-header-info__subject-total">
                      {subject.lineTotal}
                    </p>
                  </div>
                ))}
                <div className="ie-header-info__subjects-total">
                  <span>Итого</span>
                  <span>{autoInfo.amount || '0'} ₸</span>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      <InfoCard
        title={`ID #${request?.code}`}
        subtitle={
          <span
            className="ie-header-info__history-text"
            onClick={() => onHistoryModalOpenChange(true)}
          >
            История изменений
          </span>
        }
      />
    </div>
  );
};

export default HeaderInfo;
